export const BROWSER_BAR_SIZES = {
  size9: 'size9',
  size12: 'size12',
  size18: 'size18',
  size24: 'size24',
} as const;

export const DATA_HOOKS = {
  browserBar: 'browser-preview-widget-bar',
  browserContent: 'browser-preview-widget-content',
} as const;

export const SKINS = {
  neutral: 'neutral',
  gradient: 'gradient',
  custom: 'custom',
} as const;
